// components/organization/PermissionSelector.jsx
import React from "react";

const RESOURCES = [
  { key: "users",      label: "کاربران" },
  { key: "exams",      label: "آزمون‌ها" },
  { key: "results",    label: "نتایج" },
  { key: "grading",    label: "تصحیح" },
  { key: "categories", label: "دسته‌بندی‌ها" },
  { key: "support", label: "پشتیبانی" },
  { key: "resource", label: "منابع آموزشی" },
];

function hasKey(list, key) {
  return list.includes(key);
}

export default function PermissionSelector({ selected, onChange }) {
  const toggleRead = (resKey) => {
    const readKey = `org:${resKey}:read`;
    const writeKey = `org:${resKey}:write`;
    let next = [...selected];

    if (hasKey(next, readKey)) {
      // اگر write روشن است و read را خاموش کنیم، منطقی نیست؛ پس وقتی write فعّال است read را نگه می‌داریم
      if (hasKey(next, writeKey)) return;
      next = next.filter(k => k !== readKey);
    } else {
      next.push(readKey);
    }
    onChange(Array.from(new Set(next)));
  };

  const toggleWrite = (resKey) => {
    const readKey = `org:${resKey}:read`;
    const writeKey = `org:${resKey}:write`;
    let next = [...selected];

    if (hasKey(next, writeKey)) {
      // خاموش کردن write فقط خود write را برمی‌دارد؛ read را نگه می‌داریم
      next = next.filter(k => k !== writeKey);
    } else {
      // روشن کردن write → read هم باید روشن باشد
      if (!hasKey(next, readKey)) next.push(readKey);
      next.push(writeKey);
    }
    onChange(Array.from(new Set(next)));
  };

  return (
    <div className="space-y-2">
      <h3 className="font-semibold text-gray-800 text-sm mb-2">سطح دسترسی‌ها</h3>
      <div className="w-full overflow-x-auto">
        <table className="min-w-[520px] text-sm">
          <thead>
            <tr className="text-gray-600">
              <th className="text-right py-2">ماژول</th>
              <th className="text-center py-2">Read</th>
              <th className="text-center py-2">Write</th>
            </tr>
          </thead>
          <tbody>
            {RESOURCES.map((r) => {
              const readKey  = `org:${r.key}:read`;
              const writeKey = `org:${r.key}:write`;
              const readOn  = selected.includes(readKey);
              const writeOn = selected.includes(writeKey);
              return (
                <tr key={r.key} className="border-t">
                  <td className="py-2">{r.label}</td>
                  <td className="py-2 text-center">
                    <input
                      type="checkbox"
                      checked={readOn}
                      onChange={() => toggleRead(r.key)}
                      className="accent-purple-600"
                    />
                  </td>
                  <td className="py-2 text-center">
                    <input
                      type="checkbox"
                      checked={writeOn}
                      onChange={() => toggleWrite(r.key)}
                      className="accent-purple-600"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
